import List from "./List";
import Preview from "./Preview";

const Pages = {
  List,
  Preview,
};

export default Pages;
